import { useContext, useEffect, useState } from "react";

import Container from "../../components/Container";
import ContentTemplate from "../../components/Layout/contentTemplate";
import { Context } from "../../utils/store";
import Layout from "../../components/Layout";
import fetchRequestLibrary from "../../utils/fetchRequestLibrary";
import CustomHead from '../../components/CustomHead'
import getByCity from '../../utils/byCities/getByCities';
const NB_PER_BLOCKS = 9
function Ville({
    idVille,
    cityName,
    thematiques,
    breakingNews,
    cities,
    ephemeralChannels,
    liveData,
    medias,
    initialArticles,
    filteredArticles,
    auboisVousInforment,
    articlesByCity
}) {

    const context = useContext(Context);
    const [nbBlock, setNbBlock] = useState(1)
    const [articles, setArticles] = useState(articlesByCity.items)
    const [isEndReached, setIsEndReached] = useState(false)
    const [actualCityName, setActualcityName] = useState(cityName)
    /*useEffect(() => {
            if (actualCityName !== cityName) {
                setArticles(initialArticles)
                setActualcityName(cityName)
            } else {
                let articlesOfCities = filteredArticles.slice(0, NB_PER_BLOCKS * nbBlock)
                setArticles(articlesOfCities)
                if (articlesOfCities.length === filteredArticles.length) {
                    setIsEndReached(true)
                }
            }
    }, [nbBlock, cityName])*/
    
    useEffect(()=>{
        setArticles(articlesByCity.items)
    },[cityName])

    async function seeMoreFunction() {
        let moreArticles = await getByCity(idVille,NB_PER_BLOCKS,NB_PER_BLOCKS*nbBlock);
        setArticles([...articles, ...moreArticles.items]);
        setNbBlock(nbBlock+1);
    }
    return (
        <Context.Provider
            value={{
                ...context,
                cityName: cityName,
                cityId: idVille,
                thematiques,
                breakingNews,
                cities,
                ephemeralChannels,
                liveData,
                medias,
                isEndReachedSeeMore: isEndReached,
                auboisVousInforment
            }}
        >
            <Layout>
                <Container>
                    <CustomHead title={cityName} article={articles[0]} description={`Toute l'actualité de ${cityName}`}/>
                    <ContentTemplate
                        data={articles}
                        type={"cities"}
                        onClickFunction={seeMoreFunction}
                    />
                </Container>
            </Layout>
        </Context.Provider>
    );
}

export async function getServerSideProps(context) {
    let [ idVille, cityName ] = context.query.slug;

    const {
        thematiques,
        breakingNews,
        cities,
        ephemeralChannels,
        liveData,
        /*medias,*/
        auboisVousInforment
    } = await fetchRequestLibrary();

    /*let filteredArticles = medias.items.filter(e => {
        return e.ville === idVille;
    });*/
    /*let initialArticles = filteredArticles.slice(0, NB_PER_BLOCKS)*/

    let articlesByCity = await getByCity(idVille,NB_PER_BLOCKS);

    return {
        props: {
            idVille,
            cityName,
            thematiques,
            breakingNews,
            cities,
            ephemeralChannels,
            liveData,
            auboisVousInforment,
            articlesByCity,
        },
    };
}

export default Ville;
